/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./widgetChartToolboxEditor.vue?vue&type=template&id=8823c0e0"
import script from "./widgetChartToolboxEditor.vue?vue&type=script&lang=js"
export * from "./widgetChartToolboxEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports